/**
 * Settings API
 * Domain API via HTTP transport (apiTransport) to the backend /api RPC.
 */

import { OwnerSettings, TenantSettings, VendorSettings, InvestorSettings, IntegrationSettings } from '@repo/shared-types/settings';
import { apiTransport as router } from './transport';

export const settingsApi = {
  ownerSettings: {
    get: async (ownerId: string) => router.get<OwnerSettings>(`/owners/${ownerId}/settings`),
    update: async (ownerId: string, updates: Partial<OwnerSettings>) => router.patch<OwnerSettings>(`/owners/${ownerId}/settings`, updates)
  },
  tenantSettings: {
    get: async (tenantId: string) => router.get<TenantSettings>(`/tenants/${tenantId}/settings`),
    update: async (tenantId: string, updates: Partial<TenantSettings>) => router.patch<TenantSettings>(`/tenants/${tenantId}/settings`, updates)
  },
  vendorSettings: {
    get: async (vendorId: string) => router.get<VendorSettings>(`/vendors/${vendorId}/settings`),
    update: async (vendorId: string, updates: Partial<VendorSettings>) => router.patch<VendorSettings>(`/vendors/${vendorId}/settings`, updates)
  },
  investorSettings: {
    get: async (investorId: string) => router.get<InvestorSettings>(`/investors/${investorId}/settings`),
    update: async (investorId: string, updates: Partial<InvestorSettings>) => router.patch<InvestorSettings>(`/investors/${investorId}/settings`, updates)
  },
  integrationSettings: {
    list: async () => router.get<IntegrationSettings[]>('/integration-settings'),
    get: async (id: string) => router.get<IntegrationSettings>(`/integration-settings/${id}`),
    getByType: async (type: string) => router.get<IntegrationSettings>(`/integration-settings/type/${type}`),
    update: async (id: string, updates: Partial<IntegrationSettings>) => router.patch<IntegrationSettings>(`/integration-settings/${id}`, updates),
    delete: async (id: string) => router.delete<{ success: boolean }>(`/integration-settings/${id}`)
  }
};

